import { sendLog } from "@/api";

/**
 *
 * @param {*} modelType
 * 0：首页；1：7*24；2：banner；3：IPO专题；4：IPO鉴真；5：信披；6：智能财讯；7：可视化财报；8：金牛生态圈；9：要闻；10：公司；11：市场；12：基金；13：机构；14：视频；15：电子报；16：路演；
 * @param {*} detailType
 * 详情：0：文章详情；1：文章外链；2：IPO详情；3：金牛详情；4：信披详情；5：视频详情；6：财讯详情；7：可视化财报详情 8：今日新股详情
 * @param {*} method
 * 接口名
 * @param {*} param
 * 参数名，通常都是id
 * @param {*} remark
 *  中文描述
 */
export async function collect(modelType, detailType, method, param, remark) {
  console.log("🚀 ~ file: collect.js:17 ~ collect ~ detailType:", detailType);
  console.log("🚀 ~ file: collect.js:17 ~ collect ~ modelType:", modelType);
  let { code, data } = await sendLog({
    modelType,
    detailType,
    method,
    param,
    remark,
  });
}

export function getCollectName(columnId) {
  switch (columnId) {
    case 3091857:
      return {
        name: "要闻",
        type: 9,
      };
    case 3091870:
      return {
        name: "公司",
        type: 10,
      };
    case 3091878:
      return {
        name: "市场",
        type: 11,
      };
    case 3091862:
      return {
        name: "基金",
        type: 12,
      };
    case 3091837:
      return {
        name: "机构",
        type: 13,
      };
  }
}
